import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    /**        新手指导版本         */
    GUIDE_VERSION: string =  '1.0.0';
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Modules.State.ts